// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminPortalAccess = {
  accessPortalBaseUrl: "ポータル URL",
  accessLoginMode: "ログイン方式",
  accessAccountCenterUrl: "アカウントセンター URL",
  accessDefaultRedirectPath: "既定リダイレクトパス",
  accessShowHealthStatus: "ヘルス状態を表示",
  accessShowAccountCenter: "アカウントセンター入口を表示",
  accessTitle: "ポータルアクセス方針",
  accessSubtitle: "Endpoint Registry から派生した入口を確認し、ポータルの実行時方針を管理します。",
  accessNotice:
    "ポータルのアドレス、ドメイン、ポートは Endpoint Registry で管理します。このページではリダイレクトと表示方針のみを管理します。",
  accessEndpointTitle: "Registry 派生入口（読み取り専用）",
  accessEndpointSource: "入口ソース",
  accessEndpointSourceValue: "Endpoint Registry · deploy/service-endpoints.json",
  accessEndpointReadOnlyNotice:
    "入口アドレス、ドメイン、ポートはこのページでは編集できません。変更する場合は Endpoint Registry を更新し、実行時設定を再生成してください。",
  accessPolicyTitle: "ポータル実行時方針",
  accessAccountCenterUrlUnavailable: "未提供",
} as const;
